export var VehicleTypeEnum;
(function (VehicleTypeEnum) {
    VehicleTypeEnum["ICE"] = "ICE";
    VehicleTypeEnum["NOVCFCHV"] = "NOVC_FCHV";
    VehicleTypeEnum["NOVCHEV"] = "NOVC_HEV";
    VehicleTypeEnum["OVCHEV"] = "OVC_HEV";
    VehicleTypeEnum["PEV"] = "PEV";
})(VehicleTypeEnum || (VehicleTypeEnum = {}));
//# sourceMappingURL=types.js.map